<template>
  <router-view/>
</template>

<style>
:root {
  --primary-color: #003366;
  --secondary-color: #ff7800;
  --light-color: #f5f7fa;
  --text-color: #333333;
  --white: #ffffff;
  --gray: #666666;
}
body {
  color: var(--text-color);
  line-height: 1.6;
  overflow-x: hidden;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>
